export default __webpack_public_path__ + "static/media/logoMobile.9ab70614.svg";